/**
 * PATCH /prescription_details/:prescriptionId/update
 *
 * Replaces the medicines array on an existing prescription_details document.
 * Adapted from services/prescription/paginate.js pattern.
 *
 * @param {string} prescriptionId
 * @param {Array}  medicines - sanitised medicines array from buildPayload()
 * @returns {Promise} updated prescription_details document
 */
export async function updatePrescriptionDetail({ prescriptionId, medicines }) {
  const res = await window.axios({
    method: 'PATCH',
    baseURL: process.env.VUE_APP_EPRES_ENDPOINT,
    url: `admin/prescription_details/${prescriptionId}/update`,
    data: {
      medicines,
    },
  });

  return res.data;
}
